import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { WasteWastewater } from "../../../../api";

export const wasteWastewaterKeys = {
  items: () => ["wasteWastewaterItems"]
};

export function useGetWasteWastewaterItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...wasteWastewaterKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(WasteWastewater.getWasteWastewaterItems, params), config);
}

export function useAddWasteWastewaterItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(WasteWastewater.addWasteWastewaterItems, { questionnaireId, data }), config);
}

export function useUpdateWasteWastewaterItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(WasteWastewater.updateWasteWastewaterItem, { questionnaireId, recordId, data }), config);
}

export function useDeleteWasteWastewaterItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(WasteWastewater.deleteWasteWastewaterItem, { questionnaireId, recordId }), config);
}

export function useImportWasteWastewaterItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(WasteWastewater.importWasteWastewaterItems, { questionnaireId, data }), config);
}

export function useDownloadWasteWastewaterTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId }) =>
    callApi(WasteWastewater.getTemplate, questionnaireId), config);
}
